<template>
  <div class="input-dropdown">
    <label :for="inputId">{{ label }}</label>
    <select
      :id="inputId"
      :value="value"
      @change="updateModel($event.target.value)"
      :disabled="isDisabled"
    >
      <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
        :selected="value === option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    // Required props
    value: {
      // value for v-model to bind to, as well (assigned by v-model on component call)
      type: String,
      required: true,
    },
    options: {
      // array / object of objects with options. child object should contain text and value
      type: [Array, Object],
      required: true,
    },

    // Optional props
    label: String, // label text
    inputId: String, // id to input and label, cause id on component applies it to div
    placeholder: String, // placeholder text
    isDisabled: [Boolean, String], // toggle for disabled or not
  },
  methods: {
    updateModel(value) {
      // Imitate what v-model does and emit that to parent component v-model
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped></style>
